import { __assign } from "tslib";
import { Store } from '@ekuaibao/i18n';
import { Fetch } from '@ekuaibao/fetch';
import { app } from '@ekuaibao/whispered';
import { changeTheme } from './initColors';
window.getCorpStyle = function () {
    var _a, _b;
    return (_b = (_a = app.sdk.staffSetting) === null || _a === void 0 ? void 0 : _a.corpStyle) !== null && _b !== void 0 ? _b : {};
};
export function updateScopeVariable(staffSetting) {
    var _a;
    var _b, _c, _d, _e;
    var _f = staffSetting || {}, corpWordsReplaceItems = _f.corpWordsReplaceItems, corpStyle = _f.corpStyle;
    var THEME = (_b = corpStyle === null || corpStyle === void 0 ? void 0 : corpStyle.THEME) !== null && _b !== void 0 ? _b : {};
    var WORD = (_c = corpStyle === null || corpStyle === void 0 ? void 0 : corpStyle.WORD) !== null && _c !== void 0 ? _c : {};
    changeTheme({ color: (_d = THEME.customValue) === null || _d === void 0 ? void 0 : _d.color });
    if (!!(corpWordsReplaceItems === null || corpWordsReplaceItems === void 0 ? void 0 : corpWordsReplaceItems.length)) {
        var store = Store.getInstance();
        var currentLocale = (_e = staffSetting === null || staffSetting === void 0 ? void 0 : staffSetting.language) !== null && _e !== void 0 ? _e : Fetch.defaultLanguage;
        var currentScope_1 = store.currentScope;
        var corpNatureObj_1 = {};
        corpWordsReplaceItems.forEach(function (item) {
            if ((WORD === null || WORD === void 0 ? void 0 : WORD.custom) && item.brandName === currentScope_1) {
                corpNatureObj_1["__global_scope__title"] = item.replaceKey;
                return;
            }
            if ((WORD === null || WORD === void 0 ? void 0 : WORD.custom) && item.brandName.length) {
                return;
            }
            corpNatureObj_1["__global_" + item.variable] = item.replaceKey;
        });
        var currentScopeVariable = store.scopeVariables[currentLocale];
        var corpScopeVariable = (_a = {},
            _a[currentScope_1] = __assign(__assign({}, currentScopeVariable[currentScope_1]), corpNatureObj_1),
            _a);
        store.addScopeVariable(currentLocale, corpScopeVariable);
    }
}
app.updateI18nStoreScopeVariable = updateScopeVariable;
